import { atom } from 'jotai';
import { isAuthenticated, getCurrentUser } from '../login/controller/login-controller';

// Initialize with the current authentication state from localStorage
export const isAuthenticatedAtom = atom(isAuthenticated());

// Initialize with the current user data from localStorage
export const userAtom = atom(getCurrentUser());

// Remember me preference
export const rememberMeAtom = atom(localStorage.getItem('rememberMe') === 'true');

// Loading state for auth operations
export const isLoadingAtom = atom(false);

// Error message for login failures
export const loginErrorAtom = atom(null);

// Add this new atom for signup error messages
export const signupErrorAtom = atom(null);

export const tokenAtom = atom(null);